<div
  class="stock-group-column cursor-pointer"
  *ngIf="isParentGroupRow"
  (click)="toggleGroup()"
>
  <ng-container *ngIf="group; else noGroup">
    <i
      class="fas pr-2"
      [ngClass]="{
        'fa-chevron-right': !isExpanded,
        'fa-chevron-down': isExpanded,
      }"
    ></i>
    <span
      ><b>{{ group.label }}</b> ({{ group.count }})</span
    >
  </ng-container>
  <ng-template #noGroup>
    <span>None</span>
  </ng-template>
</div>
